/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { theme } from '@upright/ui/assets/styles/tokens';
import { useCarouselContext, useCarouselLayout } from '../context';

export function VerticalLines() {
  const layout = useCarouselLayout();
  const { x1, x2, y1, y2 } = layout.centerArea();
  const descriptionsArea = layout.topDescriptionsArea();
  const titlesArea = layout.topTitlesArea();

  const center = descriptionsArea.x1 + descriptionsArea.width / 2;
  // The page's divider gray, which the chart's boxes and summary bar below are drawn in too.
  const stroke = theme.color['gray-300'];

  const showTopVerticalLine = !useCarouselContext().options.hideTopDescriptionArea && !descriptionsArea.narrowMode;
  return (
    <g>
      {false && <line x1={x1} x2={x1} y1={y1} y2={y2} stroke={stroke} />}
      {false && <line x1={x2} x2={x2} y1={y1} y2={y2} stroke={stroke} />}
      {showTopVerticalLine && (
        <line x1={center} x2={center} y1={descriptionsArea.y1} y2={titlesArea.y2} stroke={stroke} />
      )}
    </g>
  );
}
